// // // 'use client';
// // // import { useState, useEffect } from 'react';
// // // import { createPortal } from 'react-dom';
// // // import { usePathname } from 'next/navigation';
// // // import { enableAnalytics, disableAnalytics } from '~/utilities/analytics';

// // // const MAX_Z = 2147483647;

// // // const baseButton = {
// // //   padding: '10px 20px',
// // //   border: 'none',
// // //   borderRadius: '6px',
// // //   cursor: 'pointer',
// // //   fontSize: '14px',
// // // };

// // // export default function CookieManager() {
// // //   const pathname = usePathname();
// // //   const [showBanner, setShowBanner] = useState(false);
// // //   const [isMobile, setIsMobile] = useState(false);
// // //   const [preferences, setPreferences] = useState({
// // //     functional: true,
// // //     analytics: false,
// // //     marketing: false,
// // //   });

// // //   const applyConsent = (prefs) => {
// // //     if (prefs.analytics) {
// // //       enableAnalytics();
// // //     } else {
// // //       disableAnalytics();
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     const mq = window.matchMedia('(max-width: 640px)');
// // //     const update = () => setIsMobile(mq.matches);
// // //     update();
// // //     mq.addEventListener('change', update);
// // //     return () => mq.removeEventListener('change', update);
// // //   }, []);

// // //   useEffect(() => {
// // //     if (showBanner && isMobile) {
// // //       const previous = document.body.style.overflow;
// // //       document.body.style.overflow = 'hidden';
// // //       return () => {
// // //         document.body.style.overflow = previous;
// // //       };
// // //     }
// // //   }, [showBanner, isMobile]);

// // //   useEffect(() => {
// // //     const open = () => setShowBanner(true);
// // //     window.addEventListener('open-cookie-settings', open);
// // //     return () => window.removeEventListener('open-cookie-settings', open);
// // //   }, []);

// // //   useEffect(() => {
// // //     if (pathname === '/maintenance') {
// // //       return;
// // //     }

// // //     const saved = localStorage.getItem('cookieConsent');

// // //     if (!saved) {
// // //       setShowBanner(true);
// // //     } else {
// // //       try {
// // //         const parsed = JSON.parse(saved);
// // //         setPreferences(parsed);
// // //         if (parsed.analytics) {
// // //           enableAnalytics();
// // //         }
// // //       } catch (e) {
// // //         console.error('Error parsing cookie consent:', e);
// // //       }
// // //     }
// // //   }, [pathname]);

// // //   const saveConsent = (newPrefs) => {
// // //     setPreferences(newPrefs);
// // //     localStorage.setItem('cookieConsent', JSON.stringify(newPrefs));
// // //     applyConsent(newPrefs);
// // //   };

// // //   const handleAcceptAll = () => {
// // //     saveConsent({ functional: true, analytics: true, marketing: true });
// // //     setShowBanner(false);
// // //   };

// // //   const handleDecline = () => {
// // //     saveConsent({ functional: true, analytics: false, marketing: false });
// // //     setShowBanner(false);
// // //   };

// // //   const handleSaveSelection = () => {
// // //     saveConsent(preferences);
// // //     setShowBanner(false);
// // //   };

// // //   const handleToggle = (type) => {
// // //     setPreferences((p) => ({ ...p, [type]: !p[type] }));
// // //   };

// // //   if (pathname === '/maintenance') {
// // //     return null;
// // //   }

// // //   if (showBanner) {
// // //     const popupStyle = isMobile
// // //       ? {
// // //           position: 'fixed',
// // //           top: '50%',
// // //           left: '50%',
// // //           transform: 'translate(-50%, -50%)',
// // //           width: 'calc(100% - 40px)',
// // //           maxHeight: '90vh',
// // //           overflowY: 'auto',
// // //           boxSizing: 'border-box',
// // //         }
// // //       : {
// // //           position: 'fixed',
// // //           bottom: '20px',
// // //           left: '20px',
// // //           right: '20px',
// // //           maxWidth: '500px',
// // //         };

// // //     const banner = (
// // //       <>
// // //         {isMobile && (
// // //           <>
// // //             {/* Navigation und Header unter das Overlay schieben */}
// // //             <style>{`
// // //               .navigation__content { z-index: 1 !important; }
// // //               .mn-panel, .mn-overlay { z-index: 1 !important; }
// // //               #headerMobileSticky,
// // //               #headerMobileStickyOverlay { z-index: 1 !important; }
// // //             `}</style>

// // //             <div
// // //               style={{
// // //                 position: 'fixed',
// // //                 top: 0,
// // //                 left: 0,
// // //                 right: 0,
// // //                 bottom: 0,
// // //                 backgroundColor: 'rgba(0, 0, 0, 0.5)',
// // //                 zIndex: MAX_Z - 1,
// // //               }}
// // //             />
// // //           </>
// // //         )}

// // //         <div
// // //           style={{
// // //             ...popupStyle,
// // //             backgroundColor: '#fff',
// // //             color: '#333',
// // //             padding: '24px',
// // //             borderRadius: '12px',
// // //             boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
// // //             zIndex: MAX_Z,
// // //             fontFamily: 'Arial, sans-serif',
// // //             fontSize: '14px',
// // //           }}
// // //         >
// // //           <div style={{ marginBottom: '15px' }}>
// // //             <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
// // //               Cookie-Einstellungen
// // //             </h3>
// // //           </div>

// // //           <p style={{ margin: '0 0 20px 0', color: '#555', lineHeight: '1.5' }}>
// // //             Wir nutzen Cookies, um dir das beste Einkaufserlebnis zu bieten.
// // //             Essenzielle Cookies sind für die Shop-Funktion notwendig.
// // //           </p>

// // //           <div style={{ marginBottom: '20px' }}>
// // //             <label
// // //               style={{
// // //                 display: 'flex',
// // //                 alignItems: 'center',
// // //                 marginBottom: '12px',
// // //                 padding: '10px',
// // //                 backgroundColor: '#f9f9f9',
// // //                 borderRadius: '6px',
// // //               }}
// // //             >
// // //               <input
// // //                 type="checkbox"
// // //                 checked
// // //                 disabled
// // //                 style={{ marginRight: '12px', width: '18px', height: '18px' }}
// // //               />
// // //               <div>
// // //                 <strong style={{ display: 'block', marginBottom: '3px' }}>
// // //                   Essenziell
// // //                 </strong>
// // //                 <span style={{ fontSize: '12px', color: '#777' }}>
// // //                   Warenkorb, Login, Stripe Payment - Immer aktiv
// // //                 </span>
// // //               </div>
// // //             </label>

// // //             <label
// // //               style={{
// // //                 display: 'flex',
// // //                 alignItems: 'center',
// // //                 marginBottom: '12px',
// // //                 padding: '10px',
// // //                 backgroundColor: '#f9f9f9',
// // //                 borderRadius: '6px',
// // //               }}
// // //             >
// // //               <input
// // //                 type="checkbox"
// // //                 checked={preferences.analytics}
// // //                 onChange={() => handleToggle('analytics')}
// // //                 style={{
// // //                   marginRight: '12px',
// // //                   width: '18px',
// // //                   height: '18px',
// // //                   cursor: 'pointer',
// // //                 }}
// // //               />
// // //               <div>
// // //                 <strong style={{ display: 'block', marginBottom: '3px' }}>
// // //                   Statistik
// // //                 </strong>
// // //                 <span style={{ fontSize: '12px', color: '#777' }}>
// // //                   Google Analytics 4 (Google Ireland Limited) zur Reichweitenmessung
// // //                 </span>
// // //               </div>
// // //             </label>

// // //             <label
// // //               style={{
// // //                 display: 'flex',
// // //                 alignItems: 'center',
// // //                 marginBottom: '12px',
// // //                 padding: '10px',
// // //                 backgroundColor: '#f9f9f9',
// // //                 borderRadius: '6px',
// // //               }}
// // //             >
// // //               <input
// // //                 type="checkbox"
// // //                 checked={preferences.marketing}
// // //                 onChange={() => handleToggle('marketing')}
// // //                 style={{
// // //                   marginRight: '12px',
// // //                   width: '18px',
// // //                   height: '18px',
// // //                   cursor: 'pointer',
// // //                 }}
// // //               />
// // //               <div>
// // //                 <strong style={{ display: 'block', marginBottom: '3px' }}>
// // //                   Marketing
// // //                 </strong>
// // //                 <span style={{ fontSize: '12px', color: '#777' }}>
// // //                   Werbe-Dienste (derzeit nicht eingebunden)
// // //                 </span>
// // //               </div>
// // //             </label>
// // //           </div>

// // //           <div
// // //             style={{
// // //               display: 'flex',
// // //               flexWrap: 'wrap',
// // //               gap: '10px',
// // //               justifyContent: 'flex-end',
// // //             }}
// // //           >
// // //             <button
// // //               onClick={handleDecline}
// // //               style={{
// // //                 ...baseButton,
// // //                 backgroundColor: '#f0f0f0',
// // //                 color: '#333',
// // //                 fontWeight: '500',
// // //               }}
// // //             >
// // //               Nur Essenzielle
// // //             </button>
// // //             <button
// // //               onClick={handleSaveSelection}
// // //               style={{
// // //                 ...baseButton,
// // //                 backgroundColor: '#f0f0f0',
// // //                 color: '#333',
// // //                 fontWeight: '500',
// // //               }}
// // //             >
// // //               Auswahl speichern
// // //             </button>
// // //             <button
// // //               onClick={handleAcceptAll}
// // //               style={{
// // //                 ...baseButton,
// // //                 backgroundColor: '#0f4c8a',
// // //                 color: '#fff',
// // //                 fontWeight: 'bold',
// // //               }}
// // //             >
// // //               Alle akzeptieren
// // //             </button>
// // //           </div>

// // //           <p
// // //             style={{
// // //               marginTop: '15px',
// // //               fontSize: '12px',
// // //               color: '#888',
// // //               textAlign: 'center',
// // //             }}
// // //           >
// // //             Du kannst deine Einstellungen jederzeit in der{' '}
// // //             <a
// // //               href="/company/cookie"
// // //               style={{ color: '#0f4c8a', textDecoration: 'underline' }}
// // //             >
// // //               Cookie-Richtlinie
// // //             </a>{' '}
// // //             ändern.
// // //           </p>
// // //         </div>
// // //       </>
// // //     );

// // //     return createPortal(banner, document.body);
// // //   }

// // //   return null;
// // // }

// // 'use client';
// // import { useState, useEffect } from 'react';
// // import { createPortal } from 'react-dom';
// // import { usePathname } from 'next/navigation';
// // import { enableAnalytics, disableAnalytics } from '~/utilities/analytics';

// // const MAX_Z = 2147483647;

// // // Bei Änderung der Kategorien (z. B. neues Marketing-Tool) erhöhen:
// // // Besucher werden dann erneut gefragt.
// // const CONSENT_VERSION = 1;

// // // Alle Buttons bewusst gleich gestaltet (kein Nudging).
// // const baseButton = {
// //   padding: '10px 20px',
// //   border: '1px solid #0f4c8a',
// //   borderRadius: '6px',
// //   cursor: 'pointer',
// //   fontSize: '14px',
// //   fontWeight: '600',
// //   backgroundColor: '#fff',
// //   color: '#0f4c8a',
// // };

// // export default function CookieManager() {
// //   const pathname = usePathname();
// //   const [showBanner, setShowBanner] = useState(false);
// //   const [isMobile, setIsMobile] = useState(false);
// //   const [preferences, setPreferences] = useState({
// //     functional: true,
// //     analytics: false,
// //   });

// //   const applyConsent = (prefs) => {
// //     if (prefs.analytics) {
// //       enableAnalytics();
// //     } else {
// //       disableAnalytics();
// //     }
// //   };

// //   useEffect(() => {
// //     const mq = window.matchMedia('(max-width: 640px)');
// //     const update = () => setIsMobile(mq.matches);
// //     update();
// //     mq.addEventListener('change', update);
// //     return () => mq.removeEventListener('change', update);
// //   }, []);

// //   useEffect(() => {
// //     if (showBanner && isMobile) {
// //       const previous = document.body.style.overflow;
// //       document.body.style.overflow = 'hidden';
// //       return () => {
// //         document.body.style.overflow = previous;
// //       };
// //     }
// //   }, [showBanner, isMobile]);

// //   useEffect(() => {
// //     const open = () => setShowBanner(true);
// //     window.addEventListener('open-cookie-settings', open);
// //     return () => window.removeEventListener('open-cookie-settings', open);
// //   }, []);

// //   useEffect(() => {
// //     if (pathname === '/maintenance') {
// //       return;
// //     }

// //     let saved = null;
// //     try {
// //       saved = localStorage.getItem('cookieConsent');
// //     } catch (e) {
// //       saved = null;
// //     }

// //     if (!saved) {
// //       setShowBanner(true);
// //       return;
// //     }

// //     try {
// //       const parsed = JSON.parse(saved);

// //       // Alte oder fehlende Version: erneut nach Einwilligung fragen
// //       if (parsed.v !== CONSENT_VERSION) {
// //         setShowBanner(true);
// //         return;
// //       }

// //       setPreferences({
// //         functional: true,
// //         analytics: !!parsed.analytics,
// //       });
// //       applyConsent(parsed);
// //     } catch (e) {
// //       console.error('Error parsing cookie consent:', e);
// //       setShowBanner(true);
// //     }
// //   }, [pathname]);

// //   const saveConsent = (newPrefs) => {
// //     const record = {
// //       functional: true,
// //       analytics: !!newPrefs.analytics,
// //       ts: Date.now(),
// //       v: CONSENT_VERSION,
// //     };
// //     setPreferences({ functional: true, analytics: record.analytics });
// //     try {
// //       localStorage.setItem('cookieConsent', JSON.stringify(record));
// //     } catch (e) {
// //       console.error('Could not store cookie consent:', e);
// //     }
// //     applyConsent(record);
// //   };

// //   const handleAcceptAll = () => {
// //     saveConsent({ analytics: true });
// //     setShowBanner(false);
// //   };

// //   const handleDecline = () => {
// //     saveConsent({ analytics: false });
// //     setShowBanner(false);
// //   };

// //   const handleSaveSelection = () => {
// //     saveConsent(preferences);
// //     setShowBanner(false);
// //   };

// //   const handleToggle = (type) => {
// //     setPreferences((p) => ({ ...p, [type]: !p[type] }));
// //   };

// //   if (pathname === '/maintenance') {
// //     return null;
// //   }

// //   if (showBanner) {
// //     const popupStyle = isMobile
// //       ? {
// //           position: 'fixed',
// //           top: '50%',
// //           left: '50%',
// //           transform: 'translate(-50%, -50%)',
// //           width: 'calc(100% - 40px)',
// //           maxHeight: '90vh',
// //           overflowY: 'auto',
// //           boxSizing: 'border-box',
// //         }
// //       : {
// //           position: 'fixed',
// //           bottom: '20px',
// //           left: '20px',
// //           right: '20px',
// //           maxWidth: '500px',
// //         };

// //     const optionStyle = {
// //       display: 'flex',
// //       alignItems: 'center',
// //       marginBottom: '12px',
// //       padding: '10px',
// //       backgroundColor: '#f9f9f9',
// //       borderRadius: '6px',
// //     };

// //     const banner = (
// //       <>
// //         {isMobile && (
// //           <>
// //             {/* Navigation und Header unter das Overlay schieben */}
// //             <style>{`
// //               .navigation__content { z-index: 1 !important; }
// //               .mn-panel, .mn-overlay { z-index: 1 !important; }
// //               #headerMobileSticky,
// //               #headerMobileStickyOverlay { z-index: 1 !important; }
// //             `}</style>

// //             <div
// //               style={{
// //                 position: 'fixed',
// //                 top: 0,
// //                 left: 0,
// //                 right: 0,
// //                 bottom: 0,
// //                 backgroundColor: 'rgba(0, 0, 0, 0.5)',
// //                 zIndex: MAX_Z - 1,
// //               }}
// //             />
// //           </>
// //         )}

// //         <div
// //           role="dialog"
// //           aria-modal="true"
// //           aria-label="Cookie-Einstellungen"
// //           style={{
// //             ...popupStyle,
// //             backgroundColor: '#fff',
// //             color: '#333',
// //             padding: '24px',
// //             borderRadius: '12px',
// //             boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
// //             zIndex: MAX_Z,
// //             fontFamily: 'Arial, sans-serif',
// //             fontSize: '14px',
// //           }}
// //         >
// //           <div style={{ marginBottom: '15px' }}>
// //             <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
// //               Cookie-Einstellungen
// //             </h3>
// //           </div>

// //           <p style={{ margin: '0 0 20px 0', color: '#555', lineHeight: '1.5' }}>
// //             Wir nutzen Cookies, um dir das beste Einkaufserlebnis zu bieten.
// //             Essenzielle Cookies sind für die Shop-Funktion notwendig. Statistik-Cookies
// //             setzen wir nur mit deiner Einwilligung.
// //           </p>

// //           <div style={{ marginBottom: '20px' }}>
// //             <label style={optionStyle}>
// //               <input
// //                 type="checkbox"
// //                 checked
// //                 disabled
// //                 style={{ marginRight: '12px', width: '18px', height: '18px' }}
// //               />
// //               <div>
// //                 <strong style={{ display: 'block', marginBottom: '3px' }}>
// //                   Essenziell
// //                 </strong>
// //                 <span style={{ fontSize: '12px', color: '#777' }}>
// //                   Warenkorb, Login, Zahlung (Stripe), Sicherheit - Immer aktiv
// //                 </span>
// //               </div>
// //             </label>

// //             <label style={optionStyle}>
// //               <input
// //                 type="checkbox"
// //                 checked={preferences.analytics}
// //                 onChange={() => handleToggle('analytics')}
// //                 style={{
// //                   marginRight: '12px',
// //                   width: '18px',
// //                   height: '18px',
// //                   cursor: 'pointer',
// //                 }}
// //               />
// //               <div>
// //                 <strong style={{ display: 'block', marginBottom: '3px' }}>
// //                   Statistik
// //                 </strong>
// //                 <span style={{ fontSize: '12px', color: '#777' }}>
// //                   Google Analytics 4 (Google Ireland Limited) zur Reichweitenmessung
// //                 </span>
// //               </div>
// //             </label>
// //           </div>

// //           <div
// //             style={{
// //               display: 'flex',
// //               flexWrap: 'wrap',
// //               gap: '10px',
// //               justifyContent: 'flex-end',
// //             }}
// //           >
// //             <button onClick={handleDecline} style={baseButton}>
// //               Nur Essenzielle
// //             </button>
// //             <button onClick={handleSaveSelection} style={baseButton}>
// //               Auswahl speichern
// //             </button>
// //             <button onClick={handleAcceptAll} style={baseButton}>
// //               Alle akzeptieren
// //             </button>
// //           </div>

// //           <p
// //             style={{
// //               marginTop: '15px',
// //               fontSize: '12px',
// //               color: '#888',
// //               textAlign: 'center',
// //             }}
// //           >
// //             Mehr dazu in der{' '}
// //             <a
// //               href="/company/cookie"
// //               style={{ color: '#0f4c8a', textDecoration: 'underline' }}
// //             >
// //               Cookie-Richtlinie
// //             </a>
// //             . Deine Auswahl kannst du jederzeit ändern.
// //           </p>
// //         </div>
// //       </>
// //     );

// //     return createPortal(banner, document.body);
// //   }

// //   return null;
// // }


// 'use client';
// import { useState, useEffect } from 'react';
// import { createPortal } from 'react-dom';
// import { usePathname } from 'next/navigation';
// import { enableAnalytics, disableAnalytics } from '~/utilities/analytics';

// const MAX_Z = 2147483647;

// // Bei Änderung der Kategorien (z. B. neues Marketing-Tool) erhöhen:
// // Besucher werden dann erneut gefragt.
// const CONSENT_VERSION = 1;

// // Alle Buttons bewusst gleich gestaltet (kein Nudging).
// const baseButton = {
//   padding: '10px 20px',
//   border: '1px solid #0f4c8a',
//   borderRadius: '6px',
//   cursor: 'pointer',
//   fontSize: '14px',
//   fontWeight: '600',
//   backgroundColor: '#fff',
//   color: '#0f4c8a',
// };

// export default function CookieManager() {
//   const pathname = usePathname();
//   const [showBanner, setShowBanner] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [preferences, setPreferences] = useState({
//     functional: true,
//     analytics: false,
//   });

//   const applyConsent = (prefs) => {
//     if (prefs.analytics) {
//       enableAnalytics();
//     } else {
//       disableAnalytics();
//     }
//   };

//   useEffect(() => {
//     const mq = window.matchMedia('(max-width: 640px)');
//     const update = () => setIsMobile(mq.matches);
//     update();
//     mq.addEventListener('change', update);
//     return () => mq.removeEventListener('change', update);
//   }, []);

//   useEffect(() => {
//     if (showBanner && isMobile) {
//       const previous = document.body.style.overflow;
//       document.body.style.overflow = 'hidden';
//       return () => {
//         document.body.style.overflow = previous;
//       };
//     }
//   }, [showBanner, isMobile]);

//   useEffect(() => {
//     const open = () => setShowBanner(true);
//     window.addEventListener('open-cookie-settings', open);
//     return () => window.removeEventListener('open-cookie-settings', open);
//   }, []);

//   useEffect(() => {
//     if (pathname === '/maintenance') {
//       return;
//     }

//     let saved = null;
//     try {
//       saved = localStorage.getItem('cookieConsent');
//     } catch (e) {
//       saved = null;
//     }

//     if (!saved) {
//       setShowBanner(true);
//       return;
//     }

//     try {
//       const parsed = JSON.parse(saved);

//       // Alte oder fehlende Version: erneut nach Einwilligung fragen
//       if (parsed.v !== CONSENT_VERSION) {
//         setShowBanner(true);
//         return;
//       }

//       setPreferences({
//         functional: true,
//         analytics: !!parsed.analytics,
//       });
//       applyConsent(parsed);
//     } catch (e) {
//       console.error('Error parsing cookie consent:', e);
//       setShowBanner(true);
//     }
//   }, [pathname]);

//   const saveConsent = (newPrefs) => {
//     const record = {
//       functional: true,
//       analytics: !!newPrefs.analytics,
//       ts: Date.now(),
//       v: CONSENT_VERSION,
//     };
//     setPreferences({ functional: true, analytics: record.analytics });
//     try {
//       localStorage.setItem('cookieConsent', JSON.stringify(record));
//     } catch (e) {
//       console.error('Could not store cookie consent:', e);
//     }
//     applyConsent(record);
//   };

//   const handleAcceptAll = () => {
//     saveConsent({ analytics: true });
//     setShowBanner(false);
//   };

//   const handleDecline = () => {
//     saveConsent({ analytics: false });
//     setShowBanner(false);
//   };

//   const handleSaveSelection = () => {
//     saveConsent(preferences);
//     setShowBanner(false);
//   };

//   const handleToggle = (type) => {
//     setPreferences((p) => ({ ...p, [type]: !p[type] }));
//   };

//   if (pathname === '/maintenance') {
//     return null;
//   }

//   if (showBanner) {
//     const popupStyle = isMobile
//       ? {
//           position: 'fixed',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           width: 'calc(100% - 40px)',
//           maxHeight: '90vh',
//           overflowY: 'auto',
//           boxSizing: 'border-box',
//         }
//       : {
//           position: 'fixed',
//           bottom: '20px',
//           left: '20px',
//           right: '20px',
//           maxWidth: '500px',
//         };

//     const optionStyle = {
//       display: 'flex',
//       alignItems: 'center',
//       marginBottom: '12px',
//       padding: '10px',
//       backgroundColor: '#f9f9f9',
//       borderRadius: '6px',
//     };

//     const banner = (
//       <>
//         {isMobile && (
//           <>
//             {/* Navigation und Header unter das Overlay schieben */}
//             <style>{`
//               .navigation__content { z-index: 1 !important; }
//               .mn-panel, .mn-overlay { z-index: 1 !important; }
//               #headerMobileSticky,
//               #headerMobileStickyOverlay { z-index: 1 !important; }
//             `}</style>

//             <div
//               style={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                 zIndex: MAX_Z - 1,
//               }}
//             />
//           </>
//         )}

//         <div
//           role="dialog"
//           aria-modal="true"
//           aria-label="Cookie-Einstellungen"
//           style={{
//             ...popupStyle,
//             backgroundColor: '#fff',
//             color: '#333',
//             padding: '24px',
//             borderRadius: '12px',
//             boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
//             zIndex: MAX_Z,
//             fontFamily: 'Arial, sans-serif',
//             fontSize: '14px',
//           }}
//         >
//           <div style={{ marginBottom: '15px' }}>
//             <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
//               Cookie-Einstellungen
//             </h3>
//           </div>

//           <p style={{ margin: '0 0 20px 0', color: '#555', lineHeight: '1.5' }}>
//             Wir nutzen Cookies, um Ihnen das beste Einkaufserlebnis zu bieten.
//             Essenzielle Cookies sind für die Shop-Funktion notwendig. Statistik-Cookies
//             setzen wir nur mit Ihrer Einwilligung.
//           </p>

//           <div style={{ marginBottom: '20px' }}>
//             <label style={optionStyle}>
//               <input
//                 type="checkbox"
//                 checked
//                 disabled
//                 style={{ marginRight: '12px', width: '18px', height: '18px' }}
//               />
//               <div>
//                 <strong style={{ display: 'block', marginBottom: '3px' }}>
//                   Essenziell
//                 </strong>
//                 <span style={{ fontSize: '12px', color: '#777' }}>
//                   Warenkorb, Login, Zahlung (Stripe), Sicherheit - Immer aktiv
//                 </span>
//               </div>
//             </label>

//             <label style={optionStyle}>
//               <input
//                 type="checkbox"
//                 checked={preferences.analytics}
//                 onChange={() => handleToggle('analytics')}
//                 style={{
//                   marginRight: '12px',
//                   width: '18px',
//                   height: '18px',
//                   cursor: 'pointer',
//                 }}
//               />
//               <div>
//                 <strong style={{ display: 'block', marginBottom: '3px' }}>
//                   Statistik
//                 </strong>
//                 <span style={{ fontSize: '12px', color: '#777' }}>
//                   Google Analytics 4 (Google Ireland Limited) zur Reichweitenmessung
//                 </span>
//               </div>
//             </label>
//           </div>

//           <div
//             style={{
//               display: 'flex',
//               flexWrap: 'wrap',
//               gap: '10px',
//               justifyContent: 'flex-end',
//             }}
//           >
//             <button onClick={handleDecline} style={baseButton}>
//               Nur Essenzielle
//             </button>
//             <button onClick={handleSaveSelection} style={baseButton}>
//               Auswahl speichern
//             </button>
//             <button onClick={handleAcceptAll} style={baseButton}>
//               Alle akzeptieren
//             </button>
//           </div>

//           <p
//             style={{
//               marginTop: '15px',
//               fontSize: '12px',
//               color: '#888',
//               textAlign: 'center',
//             }}
//           >
//             Mehr dazu in der{' '}
//             <a
//               href="/company/cookie"
//               style={{ color: '#0f4c8a', textDecoration: 'underline' }}
//             >
//               Cookie-Richtlinie
//             </a>
//             . Ihre Auswahl können Sie jederzeit ändern.
//           </p>
//         </div>
//       </>
//     );

//     return createPortal(banner, document.body);
//   }

//   return null;
// }


'use client';
import { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { usePathname } from 'next/navigation';
import { enableAnalytics, disableAnalytics } from '~/utilities/analytics';

const MAX_Z = 2147483647;

// Bei Änderung der Kategorien (z. B. neues Marketing-Tool) erhöhen:
// Besucher werden dann erneut gefragt.
const CONSENT_VERSION = 1;

// Alle Buttons bewusst gleich gestaltet (kein Nudging).
const css = `
  .ck-dialog:focus { outline: none; }

  .ck-btn {
    flex: 1 1 0;
    padding: 12px 10px;
    border: 1.5px solid #0f4c8a;
    border-radius: 8px;
    background: #fff;
    color: #0f4c8a;
    font: 600 14px/1.2 Arial, sans-serif;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    transition: background .15s, color .15s;
  }
  .ck-btn:hover { background: #eef4fb; }
  .ck-btn:active { background: #dce9f7; }
  .ck-btn:focus-visible { outline: 3px solid #f5a623; outline-offset: 2px; }

  .ck-actions { display: flex; gap: 10px; }
  .ck-actions.is-mobile { flex-direction: column; }
  .ck-actions.is-mobile .ck-btn { flex: none; width: 100%; padding: 14px; }

  .ck-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 14px;
    margin-bottom: 10px;
    background: #f5f7fa;
    border: 1px solid #e3e8ee;
    border-radius: 8px;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    transition: border-color .15s, background .15s;
  }
  .ck-option:hover:not(.is-locked) { border-color: #0f4c8a; background: #f0f5fb; }
  .ck-option.is-locked { cursor: default; }
  .ck-option strong { display: block; font-size: 14px; margin-bottom: 2px; }
  .ck-option small { font-size: 12px; color: #667; line-height: 1.4; }

  .ck-switch { position: relative; flex: none; width: 44px; height: 24px; }
  .ck-switch input {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    margin: 0;
    cursor: inherit;
  }
  .ck-track {
    position: absolute;
    inset: 0;
    border-radius: 12px;
    background: #b8c2cc;
    transition: background .2s;
    pointer-events: none;
  }
  .ck-track::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    transition: transform .2s;
  }
  .ck-switch input:checked + .ck-track { background: #0f4c8a; }
  .ck-switch input:checked + .ck-track::after { transform: translateX(20px); }
  .ck-switch input:disabled + .ck-track { opacity: .55; }
  .ck-switch input:focus-visible + .ck-track { outline: 3px solid #f5a623; outline-offset: 2px; }

  @media (prefers-reduced-motion: reduce) {
    .ck-btn, .ck-option, .ck-track, .ck-track::after { transition: none; }
  }
`;

export default function CookieManager() {
  const pathname = usePathname();
  const dialogRef = useRef(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [preferences, setPreferences] = useState({
    functional: true,
    analytics: false,
  });

  const applyConsent = (prefs) => {
    if (prefs.analytics) {
      enableAnalytics();
    } else {
      disableAnalytics();
    }
  };

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 640px)');
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  useEffect(() => {
    if (showBanner && isMobile) {
      const previous = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = previous;
      };
    }
  }, [showBanner, isMobile]);

  // Fokus beim Öffnen auf den Dialog setzen (Tastatur / Screenreader)
  useEffect(() => {
    if (showBanner && dialogRef.current) {
      dialogRef.current.focus();
    }
  }, [showBanner]);

  useEffect(() => {
    const open = () => setShowBanner(true);
    window.addEventListener('open-cookie-settings', open);
    return () => window.removeEventListener('open-cookie-settings', open);
  }, []);

  useEffect(() => {
    if (pathname === '/maintenance') {
      return;
    }

    let saved = null;
    try {
      saved = localStorage.getItem('cookieConsent');
    } catch (e) {
      saved = null;
    }

    if (!saved) {
      setShowBanner(true);
      return;
    }

    try {
      const parsed = JSON.parse(saved);

      // Alte oder fehlende Version: erneut nach Einwilligung fragen
      if (parsed.v !== CONSENT_VERSION) {
        setShowBanner(true);
        return;
      }

      setPreferences({
        functional: true,
        analytics: !!parsed.analytics,
      });
      applyConsent(parsed);
    } catch (e) {
      console.error('Error parsing cookie consent:', e);
      setShowBanner(true);
    }
  }, [pathname]);

  const saveConsent = (newPrefs) => {
    const record = {
      functional: true,
      analytics: !!newPrefs.analytics,
      ts: Date.now(),
      v: CONSENT_VERSION,
    };
    setPreferences({ functional: true, analytics: record.analytics });
    try {
      localStorage.setItem('cookieConsent', JSON.stringify(record));
    } catch (e) {
      console.error('Could not store cookie consent:', e);
    }
    applyConsent(record);
  };

  const handleAcceptAll = () => {
    saveConsent({ analytics: true });
    setShowBanner(false);
  };

  const handleDecline = () => {
    saveConsent({ analytics: false });
    setShowBanner(false);
  };

  const handleSaveSelection = () => {
    saveConsent(preferences);
    setShowBanner(false);
  };

  const handleToggle = (type) => {
    setPreferences((p) => ({ ...p, [type]: !p[type] }));
  };

  if (pathname === '/maintenance') {
    return null;
  }

  if (showBanner) {
    const popupStyle = isMobile
      ? {
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'calc(100% - 40px)',
          maxHeight: '90vh',
          overflowY: 'auto',
          boxSizing: 'border-box',
        }
      : {
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          right: '20px',
          maxWidth: '560px',
        };

    const banner = (
      <>
        <style>{css}</style>

        {isMobile && (
          <>
            {/* Navigation und Header unter das Overlay schieben */}
            <style>{`
              .navigation__content { z-index: 1 !important; }
              .mn-panel, .mn-overlay { z-index: 1 !important; }
              #headerMobileSticky,
              #headerMobileStickyOverlay { z-index: 1 !important; }
            `}</style>

            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: MAX_Z - 1,
              }}
            />
          </>
        )}

        <div
          ref={dialogRef}
          tabIndex={-1}
          className="ck-dialog"
          role="dialog"
          aria-modal="true"
          aria-label="Cookie-Einstellungen"
          style={{
            ...popupStyle,
            backgroundColor: '#fff',
            color: '#333',
            padding: '24px',
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
            zIndex: MAX_Z,
            fontFamily: 'Arial, sans-serif',
            fontSize: '14px',
          }}
        >
          <div style={{ marginBottom: '15px' }}>
            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
              Cookie-Einstellungen
            </h3>
          </div>

          <p style={{ margin: '0 0 16px 0', color: '#555', lineHeight: '1.5' }}>
            Wir nutzen Cookies, um Ihnen das beste Einkaufserlebnis zu bieten.
            Essenzielle Cookies sind für die Shop-Funktion notwendig. Statistik-Cookies
            setzen wir nur mit Ihrer Einwilligung.
          </p>

          <div style={{ marginBottom: '16px' }}>
            <label className="ck-option is-locked">
              <div>
                <strong>Essenziell</strong>
                <small>Warenkorb, Login, Zahlung (Stripe), Sicherheit – immer aktiv</small>
              </div>
              <span className="ck-switch">
                <input type="checkbox" checked disabled readOnly />
                <span className="ck-track" />
              </span>
            </label>

            <label className="ck-option">
              <div>
                <strong>Statistik</strong>
                <small>
                  Google Analytics 4 (Google Ireland Limited) zur Reichweitenmessung
                </small>
              </div>
              <span className="ck-switch">
                <input
                  type="checkbox"
                  role="switch"
                  checked={preferences.analytics}
                  onChange={() => handleToggle('analytics')}
                />
                <span className="ck-track" />
              </span>
            </label>
          </div>

          <div className={`ck-actions${isMobile ? ' is-mobile' : ''}`}>
            <button className="ck-btn" onClick={handleDecline}>
              Nur Essenzielle
            </button>
            <button className="ck-btn" onClick={handleSaveSelection}>
              Auswahl speichern
            </button>
            <button className="ck-btn" onClick={handleAcceptAll}>
              Alle akzeptieren
            </button>
          </div>

          <p
            style={{
              marginTop: '15px',
              marginBottom: 0,
              fontSize: '12px',
              color: '#666',
              textAlign: 'center',
            }}
          >
            Mehr dazu in der{' '}
            <a
              href="/company/cookie"
              style={{ color: '#0f4c8a', textDecoration: 'underline' }}
            >
              Cookie-Richtlinie
            </a>
            . Ihre Auswahl können Sie jederzeit ändern.
          </p>
        </div>
      </>
    );

    return createPortal(banner, document.body);
  }

  return null;
}